// GOLDEN PATH CODE
// An example of mutations that update the local data that is displayed on the website
// Based on

// Hooks
import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../../hooks/features';
import { getClient } from '../../../utils/getClient';
// Types
import { CreateAmbassadorRequest } from '@amzn/red-velvet-api';

const MUTATION_PREFIX = ['RedVelvetApi', 'ambassadors'];

export function useCreateAmbassador() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation({
    mutationKey: MUTATION_PREFIX.concat(['createAmbassador']),
    mutationFn: async (request: CreateAmbassadorRequest) => {
      const result = await client.createAmbassador(request);

      return {
        result,
      };
    },
    onSuccess: (data) => {
      return data;
    },
  });
}
